<template>
  <div>
    <wc-page-title title='Divisions'></wc-page-title>
    <v-container>
      <wc-data-box
        :title='iconData.title'
        :titleIcon='iconData.icon'
        :titleIconColor='iconData.iconColor'
        showSearch
        v-model='search'
      >
        <v-data-table
          dense
          :items='divisions'
          :headers='headers'
          :items-per-page='-1'
          :search='search'
          hide-default-footer
          @click:row='openDivision'
        >
          <template v-slot:item.division='{ item }'>
            <wc-division-nai :division_obj='item'></wc-division-nai>
          </template>
        </v-data-table>
      </wc-data-box>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'divisions-all',
  data: () => ({
    search: '',
    headers: [
      { text: 'Order', value: 'order', width: '90' },
      { text: 'Prefix', value: 'division_prefix', width: '90' },
      { text: 'Division', value: 'division' }
    ]
  }),
  computed: {
    iconData () {
      return this.$store.state.icons.dataBox.divisions
    },
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    }
  },
  methods: {
    openDivision (row) {
      this.$router.push({ name: 'DivisionOverview', params: { id: row.id } })
    }
  }
}
</script>
